import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VeeValidate from 'vee-validate'
import messagesEn from './locales/validator/messages/en'
import messagesPt from './locales/validator/messages/pt'
import LayoutDefault from '@/layouts/LayoutDefault'
import LayoutEmpty from '@/layouts/LayoutEmpty'
import LayoutForm from '@/layouts/LayoutForm'
import './plugins'

Vue.component('LayoutDefault', LayoutDefault)
Vue.component('LayoutEmpty', LayoutEmpty)
Vue.component('LayoutForm', LayoutForm)

Vue.config.productionTip = false
Vue.config.performance = true

Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    en: messagesEn,
    pt: messagesPt
  }
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
